import styled from 'styled-components';
import { motion } from 'framer-motion';

interface IsActiveProps {
  isActive: boolean;
  activeMenu?: string | null;
  isDefault?: boolean;
}

export const MobileMenuLiContainer = styled.div`
  width: 100%;
`;

export const MobileMenuListComponent = styled.li<IsActiveProps>`
  width: 100%;
  position: relative;

  a {
    display: block;
    width: 100%;
    padding: 16px 0;
    font-size: 15px;
    font-weight: 700;
    color: ${({ isActive, isDefault, theme }) => (isActive || isDefault ? theme.text : '#B7B7B7')};
  }
`;

export const MobileSubMenu = styled(motion.ul)<IsActiveProps>`
  width: 100%;
  max-height: 0;
  overflow: hidden;

  &.active {
    max-height: 1000px;
  }

  li {
    width: 100%;
    position: relative;

    a {
      display: block;
      width: 100%;
      padding: 12px 20px;
      font-size: 15px;
      font-weight: 700;
      color: ${({ theme }) => theme.text};
    }
  }
`;

export const DropDownBtn = styled.button<IsActiveProps>`
  all: unset;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: ${({ isActive }) =>
    isActive ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)'};
  transition: 0.5s;
`;
